<div class="email-preview-container">
	<div *ngIf="loading" class="loading-message">Loading email...</div>

	<div *ngIf="error" class="error-message">
		<h2>Unable to load email</h2>
		<p>The requested email could not be found or has expired.</p>
	</div>

	<div *ngIf="!loading && !error" class="email-content" [innerHTML]="emailHtml"></div>
</div>
